import { render, staticRenderFns } from "./BatchIdentificationCarousel.vue?vue&type=template&id=435b543a&scoped=true"
import script from "./BatchIdentificationCarousel.vue?vue&type=script&lang=ts"
export * from "./BatchIdentificationCarousel.vue?vue&type=script&lang=ts"
import style0 from "./BatchIdentificationCarousel.vue?vue&type=style&index=0&id=435b543a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "435b543a",
  null
  
)

export default component.exports